import {request, serviceUrl} from "@/utils/request";


//保存联动视频
export function saveDeviceLinkage(params) {
    return request({
        method: 'post',
        url: serviceUrl.deviceService + '/device/linkage/save',
        data: params
    })
}

//获取最新的告警数据
export function getLinkageList() {
    return request({
        url: serviceUrl.deviceService + '/device/linkage/list',
    })
}

// 启用/停用告警屏蔽策略
export function deviceLinkSwitch(id, isEnable) {
    return request({
        url: serviceUrl.deviceService + '/device/linkage/deviceLinkSwitch',
        params: {id, isEnable}
    })
}

// 删除告警屏蔽策略
export function deviceLinkDelete(id) {
    return request({
        method: 'DELETE',
        url: serviceUrl.deviceService + '/device/linkage/deviceLinkDelete',
        params: {id}
    })
}


// 获取告警屏蔽策略
export function getWithConditionsAndActionsById(id) {
    return request({
        url: serviceUrl.deviceService + '/device/linkage/getWithConditionsAndActionsById',
        params: {id}
    })
}

//编辑联动视频
export function modifyDeviceLinkage(params) {
    return request({
        method: 'post',
        url: serviceUrl.deviceService + '/device/linkage/update',
        data: params
    })
}

// 判断该设备是否有启动的联动视频
export function isEnableByDeviceId(deviceId) {
  return request({
    url: serviceUrl.deviceService + '/device/linkage/isEnableByDeviceId',
    params: {deviceId}
  })
}
